module.exports = __webpack_public_path__ + "static/media/stockhausen_folkwang_7.d2b41aeb.jpg";